/**
 * @file CopaLoader.js
 * @description Loader temático da Copa: bola de futebol girando e quicando
 * sobre uma sombra, com as 5 estrelas do penta acendendo em sequência.
 * Usado na abertura do site e na geração de PDF.
 */

// Bola de futebol clássica (Telstar) em SVG
const BolaFutebol = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <circle cx="50" cy="50" r="47" fill="#FFFFFF" stroke="#0C110F" strokeWidth="2" />
    {/* Pentágono central */}
    <polygon points="50,27 67,40 60.5,61 39.5,61 33,40" fill="#0C110F" />
    {/* Costuras radiais até as bordas */}
    <path
      d="M50 27 V5 M67 40 L89 33 M60.5 61 L74 83 M39.5 61 L26 83 M33 40 L11 33"
      stroke="#0C110F"
      strokeWidth="2.5"
      fill="none"
    />
    {/* Pentágonos parciais das bordas */}
    <path d="M50 5 L61 9 L67 5 Z M50 5 L39 9 L33 5 Z" fill="#0C110F" />
    <path d="M89 33 L86 45 L93 49 Z" fill="#0C110F" />
    <path d="M11 33 L14 45 L7 49 Z" fill="#0C110F" />
    <path d="M74 83 L62 84 L60 92 Z" fill="#0C110F" />
    <path d="M26 83 L38 84 L40 92 Z" fill="#0C110F" />
  </svg>
);

const CopaLoader = ({ label = "Carregando...", fullscreen = false }) => {
  const conteudo = (
    <div className="flex flex-col items-center gap-7">
      {/* Bola + sombra */}
      <div className="relative w-28 h-28">
        {/* Brilho dourado de fundo */}
        <div className="absolute top-1 left-1/2 -translate-x-1/2 w-20 h-20 bg-ouro/20 blur-2xl rounded-full" />
        {/* Sombra no chão */}
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-14 h-2.5 rounded-[50%] bg-black animate-copa-sombra" />
        {/* Bola quicando (translateY) com giro interno (rotate) */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2">
          <div className="animate-copa-quicar">
            <BolaFutebol className="w-14 h-14 animate-copa-girar drop-shadow-lg" />
          </div>
        </div>
      </div>

      {/* Estrelas do penta acendendo em sequência */}
      <div className="flex flex-col items-center gap-2.5">
        <div className="flex gap-1.5">
          {[...Array(5)].map((_, i) => (
            <span
              key={i}
              className="block w-2 h-2 rounded-full bg-brasil-yellow animate-copa-brilho"
              style={{ animationDelay: `${i * 0.18}s` }}
            />
          ))}
        </div>
        <p className="text-sm font-medium text-gray-300">{label}</p>
      </div>
    </div>
  );

  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-campo-950/90 backdrop-blur-sm">
        {conteudo}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-24">{conteudo}</div>
  );
};

export default CopaLoader;
